import axios from "axios";

// const url = "http://10.50.107.235:3000";
const url = "https://portal.meti-box.be";

axios.defaults.baseURL = url;
